import React from 'react';
import AddCard from './AddCard';
import './Grid.css';

const Grid = ({ items, renderCard, onAddClick, square = true }) => {
  return (
    <div className={`grid ${square ? 'grid--square' : ''}`}>
      {items.map((item) => (
        <div key={item.id}>
          {renderCard(item)}
        </div>
      ))}
      {onAddClick && <AddCard onClick={onAddClick} />}
    </div>
  );
};

export default Grid;